import { Grid, Text, Bones, Box } from '@simplywallst/ui-core';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';

export const LoadingState = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return (
    <Grid gap="x2" row="repeat(2, auto)">
      <Box paddingXLg="x0" paddingY="x2" paddingX="x2">
        <Bones minHeight="40px" maxWidth="175px" />
      </Box>
      <Grid
        templateRows="auto auto"
        templateRowsMd="auto"
        templateColumnsMd="auto 32%"
        gap="16px"
      >
        <Grid gapLg="4px" backgroundColor="noir" borderRadiusLg="x1">
          <div>
            <Grid
              padding="x2"
              paddingTop="x2"
              paddingBottomLg="x2"
              paddingRight="x1_5"
              paddingLeftLg="x3"
            >
              <Grid gap="16px">
                <Bones minHeight="25px" maxWidth="150px" />
                <Box overflow="auto">
                  <Grid templateColumns="repeat(3, max-content)" gap="32px">
                    <Grid gap="12px" templateColumns="4px max-content">
                      <Grid
                        width="4px"
                        backgroundColor="darkerGray"
                        borderRadius="x1_25"
                      />
                      <Grid gap="2px">
                        <Bones minHeight="24px" minWidth="100px" />
                        <Bones minWidth="100px" />
                      </Grid>
                    </Grid>
                    <Grid gap="12px" templateColumns="4px max-content">
                      <Grid
                        width="4px"
                        backgroundColor="darkerGray"
                        borderRadius="x1_25"
                      />
                      <Grid gap="2px">
                        <Bones minHeight="24px" minWidth="100px" />
                        <Bones minWidth="100px" />
                      </Grid>
                    </Grid>
                    <Grid gap="12px" templateColumns="4px max-content">
                      <Grid
                        width="4px"
                        backgroundColor="darkerGray"
                        borderRadius="x1_25"
                      />
                      <Grid gap="2px">
                        <Bones minHeight="24px" minWidth="100px" />
                        <Bones minWidth="100px" />
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </div>
          <Box
            position="relative"
            padding="x2"
            paddingTopLg="x2"
            paddingBottomLg="x2"
            paddingRightLg="x3"
            paddingLeftLg="x3"
          >
            {!isMobileScreen ? (
              <Box
                position="absolute"
                right="24px"
                backgroundColor="noir"
                padding="x0_5"
                borderRadius="x1"
              >
                <Grid templateColumns="1fr">
                  <Bones minWidth="200px" minHeight="30px" />
                </Grid>
              </Box>
            ) : null}
            <Grid
              paddingBottom="x2"
              gap="32px"
              templateColumns="max-content max-content"
              alignItems="center"
            >
              <Grid
                templateRows="min-content 23px"
                templateRowsLg="min-content 26px"
                alignItems="center"
              >
                <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
                  Holdings
                </Text>
                <Bones minHeight="12px" maxWidth="50px" />
              </Grid>
              <Grid
                templateRows="min-content 23px"
                templateRowsLg="min-content 26px"
                alignItems="center"
              >
                <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
                  Market
                </Text>
                <Bones minHeight="12px" maxWidth="50px" />
              </Grid>
            </Grid>
            <Grid templateColumns="1fr">
              <Bones minHeight="200px" />
            </Grid>
          </Box>
        </Grid>
        <Grid backgroundColor="noir" padding="x2" borderRadius="x1" gap="16px">
          <Grid templateColumns="auto" templateRows="24px" alignItems="center">
            <Bones minHeight="25px" maxWidth="150px" />
          </Grid>
          <Grid placeContent="center">
            <Box width={220}>
              <Bones minHeight="206px" maxWidth="218px" borderRadius="x14" />
            </Box>
          </Grid>
          <Bones minHeight="25px" />
          <Grid
            templateColumns="max-content"
            justifyContent="start"
            alignItems="center"
            gap="16px"
          >
            <Bones minHeight="25px" maxWidth="150px" />
          </Grid>
          <Grid templateColumns="repeat(3, 75px)" gap="8px">
            <Box borderRadius="x0_5">
              <Bones minHeight="25px" />
            </Box>
            <Box borderRadius="x0_5">
              <Bones minHeight="25px" />
            </Box>
            <Box borderRadius="x0_5">
              <Bones minHeight="25px" />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
